/* eslint-disable */
import { useTranslation } from "react-i18next";
import React from "react";
import { Paper, Button } from "@mui/material";
import Swal from "sweetalert2";

export default function CompleteTopicModal({ handleClose, handleCompleted,special,vote }) {
  const { t } = useTranslation();
  return (
    <Paper
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-evenly",
        width: "550px",
        height: "220px",
      }}
    >
      <h4>{vote ? t("modals:sendForRating") : t("modals:completeTopic")}</h4>
      <p>
        {vote
          ? t("modals:confirmSendForRating")
          : t("modals:confirmCompleteTopic")}
      </p>
      <div style={{ display: "flex" }}>
        <Button
          onClick={() => handleClose()}
          disableRipple
          disableFocusRipple
          variant="contained"
          sx={{
            marginRight: "1rem",
            color: "black",
            backgroundColor: "#FFFFFF",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#FFFFFF",
            },
          }}
        >
          {t("cancel")}
        </Button>
        <Button
          onClick={() => {
            handleCompleted();
            handleClose();
            if(!special) Swal.fire(t("modals:topicCompleted"), "", "success");
          }}
          disableRipple
          disableFocusRipple
          variant="contained"
          sx={{
            marginRight: "1rem",
            color: "#FFFFFF",
            backgroundColor: "#01D088",
            cursor: "pointer",
            "&:hover": {
              backgroundColor: "#01D088",
            },
          }}
        >
          {vote ? t("modals:send") : t("modals:completeChat")}
        </Button>
      </div>
    </Paper>
  );
}
